export default "__VITE_ASSET__CmkubZBc__"